const keyMap = {
  UNDO: ['Control+z', 'command+z'],
  REDO: ['Control+y', 'shift+Control+z', 'command+y', 'shift+command+y'],

  // MOVE_UP: ['Control+up', 'command+up'],
  // MOVE_DOWN: ['Control+down', 'command+down'],
  // ADD_SHELF: ['Control+n', 'command+n'],
  // DUPLICATE_SHELF: ['Control+c Control+v', 'command+c command+v'],
};

export const globalKeyMap = {
  PIECE_LIST: '*',
  DELETE: 'del',
  UP_SELECTION: ['up'],
  DOWN_SELECTION: ['down'],
  ALL_SELECTION: ['Control+a', 'command+a'],
};

export default keyMap;
